import { storeArticleMedia } from '../article/article-slice';

import type { AssetContainerModel } from 'js/src/client';
import { ApiService, SlideBackgroundModelTypeEnum } from 'js/src/client';
import { Toast } from 'js/src/components/common/Toast';
import { selectDocumentId } from 'js/src/data/document';
import { convertImmutableSlideBackgroundToImmutableAssetContainer } from 'js/src/data/media';
import type { ImmutableMap } from 'js/src/libs/consts';
import { ImmutableFromJS } from 'js/src/libs/consts';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';
import uuid from 'js/src/libs/uuid';
import type { GetRootState } from 'js/src/luminary/luminary-redux-connect-types';

// TODO: refactor and reuse loadArticleMedia as part of the ticket to display the images - https://lumen5.atlassian.net/browse/MR-3556
export function loadDocumentMedia(
    onSuccessCallback: (() => void) | undefined = undefined,
    systemTriggered = true,
    parentActionGroup = uuid(),
) {
    return (dispatch: AppDispatch, getState: GetRootState) => {
        const documentId = selectDocumentId(getState());
        if (documentId === null) {
            throw new Error('documentId is null');
        }
        ApiService.documentsImagesList({ path: { documents_pk: documentId } })
            .then((response) => {
                const documentMedia = response.data.reduce(
                    (map: Record<string, ImmutableMap<AssetContainerModel>>, asset) => {
                        // note: only supports images right now
                        const imageAsset = asset[SlideBackgroundModelTypeEnum.IMAGE];
                        if (!imageAsset) {
                            throw new Error('invalid media asset – expecting image!');
                        }
                        map[imageAsset.source_id] =
                            convertImmutableSlideBackgroundToImmutableAssetContainer(
                                ImmutableFromJS(asset),
                            );
                        return map;
                    },
                    {},
                );
                dispatch(
                    storeArticleMedia({
                        articleMedia: documentMedia,
                        systemTriggered,
                        parentActionGroup,
                    }),
                );
                onSuccessCallback && onSuccessCallback();
            })
            .catch((err: unknown) => {
                ErrorReporter.capture(err);
                Toast.error('Error loading document media');
            });
    };
}
